import { Dispatch, SetStateAction, useEffect } from 'react';

import * as EventEmitter from '@/utils/event-emitter';

const useModalEmitters = ({
  open,
  id,
  setShowModal,
}: {
  open: boolean;
  id: string;
  setShowModal: Dispatch<SetStateAction<boolean>>;
}) => {
  // broadcast event whether this modal is open/closed
  // useModal listens to modal-status; useIsModalOpen listens to modal-status
  useEffect(() => {
    EventEmitter.broadcastEvent(`${id}::modal-status`, open);
  }, [id, open]);

  // listen for toggle / open / close requests
  useEffect(() => {
    const handleToggle = () => setShowModal((prev) => !prev);
    const handleOpen = () => setShowModal(true);
    const handleClose = () => setShowModal(false);

    EventEmitter.addEventListener(`${id}::modal-toggle`, handleToggle);
    EventEmitter.addEventListener(`${id}::modal-open`, handleOpen);
    EventEmitter.addEventListener(`${id}::modal-close`, handleClose);

    return () => {
      EventEmitter.removeEventListener(`${id}::modal-toggle`, handleToggle);
      EventEmitter.removeEventListener(`${id}::modal-open`, handleOpen);
      EventEmitter.removeEventListener(`${id}::modal-close`, handleClose);
    };
  }, [id, setShowModal]);
};

export default useModalEmitters;
